import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
  BotDetectionUtils,
  tryInitBotDetection,
  botDetectionServiceUiConstants,
  botDetectionChallengeAppearance,
  setupPreRenderDetection,
} from './utils/botDetectionHelper';
import './splunk-instrumentation';
import { getEnvironmentFromHost } from './api/endpoints';

const environmentIsProd = getEnvironmentFromHost(window.location.hostname) === 'prod';
const botUtils: BotDetectionUtils | undefined = tryInitBotDetection(
  console.log,
  environmentIsProd ? botDetectionServiceUiConstants.apiKey.prod : botDetectionServiceUiConstants.apiKey.nonProd
);
botUtils?.setChallengeAppearance(botDetectionChallengeAppearance);

setupPreRenderDetection();

botUtils?.loadComplete.finally(() => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.error('Root element not found');
  }
});
